import moment from "moment";

export function convertIsoDateToStandardFormat(isoDate) {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const dateObj = new Date(isoDate);

  const year = dateObj.getUTCFullYear();
  const monthIndex = dateObj.getUTCMonth();
  const day = dateObj.getUTCDate();

  const month = months[monthIndex];

  return `${month} ${day}, ${year}`;
}

export function convertSecondsToMS(seconds) {
  return moment.utc(seconds * 1000).format("mm:ss");
}

export function convertDateTimeObjToMoment(dateTime, withLocalTimezone = false, use24HourClock = false) {
  if (!dateTime) return;

  const { date, hour, minute, division } = dateTime;

  if (use24HourClock) {
    const dateTimeString = `${date} ${hour}:${minute}`;

    return withLocalTimezone
      ? moment.tz(dateTimeString, "DD-MM-yyyy HH:mm", moment.tz.guess())
      : moment(dateTimeString, "DD-MM-yyyy HH:mm");
  }

  const dateTimeString = `${date} ${hour}:${minute} ${division}`;

  return withLocalTimezone
    ? moment.tz(dateTimeString, "DD-MM-yyyy hh:mm A", moment.tz.guess())
    : moment(dateTimeString, "DD-MM-yyyy hh:mm A");
}

export const IST_TIMEZONE = "Asia/Kolkata";

export function parseTimeStringToSeconds(timeString) {
  const [hours, minutes, seconds, milliseconds] = timeString.split(":").map(Number);
  const totalSeconds = moment
    .duration({
      hours: hours || 0,
      minutes: minutes || 0,
      seconds: seconds || 0,
      milliseconds: milliseconds || 0,
    })
    .asSeconds();

  return parseFloat(totalSeconds.toFixed(3));
}

export function parseTimeStringToIntegerSeconds(timeString) {
  const [hours, minutes, seconds, milliseconds] = timeString.split(":").map(Number);
  const totalSeconds = moment
    .duration({
      hours: hours || 0,
      minutes: minutes || 0,
      seconds: seconds || 0,
      milliseconds: milliseconds || 0,
    })
    .asSeconds();

  return totalSeconds;
}

export const formatDatafeedDateToLocalDate = (dateStr) => {
  const date = new Date(dateStr);

  // Get UTC components, then add IST offset
  const utcTime = date.getTime();
  const istTime = utcTime + (5 * 60 + 30) * 60 * 1000;
  const istDate = new Date(istTime);

  const day = istDate.getUTCDate();
  const month = istDate.getUTCMonth();
  const year = istDate.getUTCFullYear();

  const isoDate = new Date(Date.UTC(year, month, day)).toISOString();
  return isoDate;
};

/**
 * Formats a date into various common formats
 * @param {string|Date} date - The date to format
 * @param {string} format - The format type: 'DD_MMM_YYYY' | 'DD_MM_YYYY'
 * @returns {string} Formatted date string
 */
export function formatDate(date, format = "DD_MMM_YYYY") {
  const dateObj = new Date(date);
  const day = String(dateObj.getDate()).padStart(2, "0");
  const year = dateObj.getFullYear();

  switch (format) {
    case "DD_MMM_YYYY":
      const month = dateObj.toLocaleString("en-US", { month: "short" }).toUpperCase();
      return `${day} ${month} ${year}`;

    case "DD_MM_YYYY":
      const monthNumber = String(dateObj.getMonth() + 1).padStart(2, "0");
      return `${day}.${monthNumber}.${year}`;

    default:
      throw new Error(`Unsupported format: ${format}`);
  }
}
